import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#0F1F3C] text-white" data-testid="main-footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <h3 className="font-serif text-3xl mb-6">Le Château d'Azur</h3>
            <p className="text-white/60 font-sans text-sm leading-relaxed mb-8 max-w-md">
              A haven of refined luxury on the French Riviera, where timeless elegance meets 
              Mediterranean splendor. Experience the art of hospitality at its finest.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-sans font-semibold text-[#D4AF37] mb-6">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/rooms"
                  className="text-white/60 hover:text-white text-sm font-sans transition-colors"
                >
                  {t('nav.rooms')}
                </Link>
              </li>
              <li>
                <Link
                  to="/experiences"
                  className="text-white/60 hover:text-white text-sm font-sans transition-colors"
                >
                  {t('nav.experiences')}
                </Link>
              </li>
              <li>
                <Link
                  to="/gallery"
                  className="text-white/60 hover:text-white text-sm font-sans transition-colors"
                >
                  {t('nav.gallery')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-sans font-semibold text-[#D4AF37] mb-6">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 mt-1 text-[#D4AF37]" />
                <span className="text-white/60 text-sm font-sans">
                  123 Promenade des Anglais<br />
                  06000 Nice, France
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-white/60 text-sm font-sans">+33 4 93 00 00 00</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-white/60 text-sm font-sans">reservations@chateaudazur.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/40 text-xs font-sans">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-white/40 hover:text-white text-xs font-sans transition-colors">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-white/40 hover:text-white text-xs font-sans transition-colors">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
